import { useState } from "react";
import { RegexFieldMatcher } from "../../../models/matchers/RegexFieldMatcher";
import { RegexValidatorResponse } from "../../../models/regex/RegexValidator";
import { DlfMatcherLabel } from "../../inputGroup/DlfMatcherLabel";
import { InputGroup } from "../../inputGroup/InputGroup";
import { RegexError } from "../../regex/RegexError";
import { RegexInput } from "../../regex/RegexInput";
import { FieldMatcherEditorChildProps } from "../FieldMatcherEditor";

export { RegexFieldMatcherEditor, Props as RegexFieldMatcherEditorProps };

type Props = {
  matcher: RegexFieldMatcher;
  update: (matcher: RegexFieldMatcher) => void;
  reusable?: boolean;
} & FieldMatcherEditorChildProps<RegexFieldMatcher>;

const RegexFieldMatcherEditor = (props: Props) => {
  const [error, setError] = useState<RegexValidatorResponse | undefined>();

  return (
    <div className={"fieldMatcherEditor regexDlfEditor"}>
      <InputGroup button={props.button != undefined}>
        <DlfMatcherLabel label={"Regex"} {...props} />

        <RegexInput
          initialValue={props.matcher.regex}
          updated={(result) => {
            setError(result);
            if (result.valid) {
              props.matcher.regex = result.regex;
              props.update(props.matcher);
            }
          }}
        />
        {props.button && props.button}
      </InputGroup>
      <RegexError error={error} />
    </div>
  );
};
